import { Spinner } from "@swivl-mono/ui";
import * as React from "react";
import { FaPlusCircle, FaSearch, FaTimesCircle } from "react-icons/fa";

import { QuestsModel, WorkflowsJourney } from "../../../../../Models/Quests/Quests.Model";
import "./MatrixQuestMenu.scss";

interface MatrixQuestMenuJourneyItemAddQuestViewProps {
  item: any;
  onChange(e);
  newQuestName: string;
  cancelClicked();
  isSavingNewQuest: boolean;
}

class MatrixQuestMenuJourneyItemAddQuestView extends React.Component<MatrixQuestMenuJourneyItemAddQuestViewProps> {
  componentDidMount() {
    const input = document.getElementById("newQuestFromMatrixInput");
    if (input) {
      input.focus();
    }
  }
  render() {
    if (this.props.isSavingNewQuest) {
      return (
        <div className="addNewQuestView isSaving">
          <Spinner />
        </div>
      );
    }

    return (
      <div className="addNewQuestView">
        <div className="title">
          Add Quest To {this.props.item.name}
          <div className="cancelButton" onClick={this.props.cancelClicked}>
            <FaTimesCircle />
          </div>
        </div>
        <input
          className="font-poppins font-semibold"
          id="newQuestFromMatrixInput"
          onChange={this.props.onChange}
          value={this.props.newQuestName}
          placeholder="Quest name..."
        />
        <div className="subtitle">(Hit enter to save)</div>
      </div>
    );
  }
}

interface MatrixQuestMenuJourneyItemProps {
  item: any;
  index: number;
  focus: number;
  addQuestToJourney: string;
  setAddQuestToJourney(journeySlug);
  newQuestName: string;
  onChangeNewQuestName(e);
  cancelNewQuestClicked();
  isSavingNewQuest: boolean;
}
class MatrixQuestMenuJourneyItem extends React.Component<MatrixQuestMenuJourneyItemProps> {
  constructor(props) {
    super(props);

    this.setAddQuestToJourney = this.setAddQuestToJourney.bind(this);
  }

  setAddQuestToJourney(e) {
    e.stopPropagation();
    this.props.setAddQuestToJourney(this.props.item.slug);
  }

  render() {
    const className = this.props.index === this.props.focus ? "MatrixQuestMenuJourneyItem focused" : "MatrixQuestMenuJourneyItem";

    let addNewQuest, shadowView;
    if (this.props.addQuestToJourney === this.props.item.slug && this.props.item.slug.length) {
      shadowView = <div className="shadowView" onClick={this.props.cancelNewQuestClicked} />;
      addNewQuest = (
        <MatrixQuestMenuJourneyItemAddQuestView
          item={this.props.item}
          onChange={this.props.onChangeNewQuestName}
          newQuestName={this.props.newQuestName}
          cancelClicked={this.props.cancelNewQuestClicked}
          isSavingNewQuest={this.props.isSavingNewQuest}
        />
      );
    }

    return (
      <div className={className} id={"menu_item_" + this.props.index}>
        {this.props.item.name}
        <div className="addQuest" onClick={this.setAddQuestToJourney}>
          <span>Add Quest</span>
          <FaPlusCircle />
        </div>
        {addNewQuest}
        {shadowView}
      </div>
    );
  }
}

interface MatrixQuestMenuQuestItemProps {
  item: any;
  index: number;
  focus: number;
  setQuest(questSlug);
}

class MatrixQuestMenuQuestItem extends React.Component<MatrixQuestMenuQuestItemProps> {
  constructor(props) {
    super(props);
    this.questClicked = this.questClicked.bind(this);
  }
  questClicked() {
    this.props.setQuest(this.props.item.slug);
  }
  render() {
    const className = this.props.index === this.props.focus ? "MatrixQuestMenuQuestItem focused" : "MatrixQuestMenuQuestItem";
    return (
      <div className={className} id={"menu_item_" + this.props.index} onClick={this.questClicked}>
        {this.props.item.name}
      </div>
    );
  }
}

interface Props {
  workflows: WorkflowsJourney[];
  setQuest(questSlug);
  setShowMenu(showMenu, two, three);
}

interface State {
  searchQuery: string;
  focus: number;
  newQuestName: string;
  addQuestToJourney: string;
  isSavingNewQuest: boolean;
}
export default class MatrixQuestMenu extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { searchQuery: "", focus: 0, newQuestName: "", addQuestToJourney: "", isSavingNewQuest: false };

    this.onChangeNewQuestName = this.onChangeNewQuestName.bind(this);
    this.cancelNewQuestClicked = this.cancelNewQuestClicked.bind(this);
    // this.keydownHandler = this.keydownHandler.bind(this)
    this.setAddQuestToJourney = this.setAddQuestToJourney.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.searchOnChange = this.searchOnChange.bind(this);
  }

  componentDidMount() {
    const input = document.getElementById("questMenuSearchField");
    if (input) {
      input.focus();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.focus != prevState.focus) {
      const questMenuSearchField = document.getElementById("questMenuSearchField");
      if (questMenuSearchField && this.state.focus != 0) {
        questMenuSearchField.blur();
      }
      if (questMenuSearchField && this.state.focus === 0) {
        questMenuSearchField.focus();
      }
    }
  }

  cancelNewQuestClicked() {
    if (this.state.isSavingNewQuest) {
      return;
    }
    this.setState({ newQuestName: "" });
    this.setAddQuestToJourney(null);
  }
  onChangeNewQuestName(e) {
    this.setState({ newQuestName: e.target.value });
  }
  /*
    keydownHandler(event) {
      const key = event.which;
      if (this.state.addQuestToJourney ) {
        if (key === 27) {
          this.cancelNewQuestClicked()
        }
        if (key === 13 && this.state.newQuestName.length > 0) {
          this.createNewQuest()
        }
        return;
      }
      if (key === 38 && this.state.focus > 0) { this.setState({focus:this.state.focus - 1});   return; }
      const options = this.getOptions();
      if (key === 40 && this.state.focus < options.length) {
         this.setState({focus:this.state.focus + 1});
      }
      if (key === 13 && this.state.focus > 0) {
        let option = options[this.state.focus - 1]
  
        if (option.isJourney) {
          this.setState({addQuestToJourney:option.slug!})
        } else {
          this.props.setQuest(option.slug);
        }
      }
  
      if (key === 27) {
        this.props.setShowMenu(null, null, true);
  
      }
  
    }
      */
  createNewQuest() {
    this.setState({ isSavingNewQuest: true });
    const journey = QuestsModel.getJourney(this.state.addQuestToJourney);

    QuestsModel.addNewQuestToJourney(journey!, this.state.newQuestName).then((newQuest) => {
      this.setState({ isSavingNewQuest: false, searchQuery: "", focus: 0, newQuestName: "", addQuestToJourney: "" });
      this.props.setQuest(newQuest.slug);
    });
  }

  setAddQuestToJourney(journeySlug) {
    this.setState({ addQuestToJourney: journeySlug, newQuestName: "" });
  }

  searchOnChange(e) {
    this.setState({ searchQuery: e.target.value, focus: 0 });
  }

  getOptions() {
    const workflows = this.props.workflows;

    var options: any = [{ name: "Clear", slug: undefined, isJourney: false }];
    if (workflows) {
      for (var i = 0; i < workflows.length; i++) {
        const workflow = workflows[i];

        if (workflow.isUnassignedGroup) {
          options.push({ name: "Unassigned", slug: "", isJourney: true });
        } else {
          options.push({ name: workflow.journey!.name, slug: workflow!.journey!.slug!, isJourney: true });
        }
        for (var q = 0; q < workflow.quests.length; q++) {
          options.push({ slug: workflow.quests[q]!.slug, name: workflow.quests[q].name, isJourney: false });
        }
      }
    }
    if (this.state.searchQuery.length) options = options.filter((item) => item.name.toLowerCase().includes(this.state.searchQuery.toLowerCase()));

    return options;
  }

  render() {
    const options = this.getOptions();
    const list = options.map((item, index) => {
      if (item.isJourney) {
        return (
          <MatrixQuestMenuJourneyItem
            key={item.slug}
            item={item}
            index={index + 1}
            focus={this.state.focus}
            addQuestToJourney={this.state.addQuestToJourney}
            setAddQuestToJourney={this.setAddQuestToJourney}
            newQuestName={this.state.newQuestName}
            onChangeNewQuestName={this.onChangeNewQuestName}
            cancelNewQuestClicked={this.cancelNewQuestClicked}
            isSavingNewQuest={this.state.isSavingNewQuest}
          />
        );
      } else {
        return <MatrixQuestMenuQuestItem key={item.slug} item={item} index={index + 1} focus={this.state.focus} setQuest={this.props.setQuest} />;
      }
    });

    return (
      <div className="MatrixQuestMenu">
        <div className={this.state.focus === 0 ? "searchField focused" : "searchField"}>
          <FaSearch />
          <input className="font-poppins font-semibold" onChange={this.searchOnChange} value={this.state.searchQuery} id="questMenuSearchField" />
        </div>
        {list}
      </div>
    );
  }
}
